import api from './api';

export const tokenService = {
  getAll,
  getById,
  create,
  update,
  destroy
};

function getAll(page = 1, limit = 25, status = '', query = '') {
  let queryStr = `?page=${page}&limit=${limit}${status && `&status=${status}`}${query && `&query=${query}`}`;
  return api.get(`${process.env.VUE_APP_ROOT_API}/tokens${queryStr}`);
}

function getById(id) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/tokens/${id}`);
}

function create(token) {
  return api.post(`${process.env.VUE_APP_ROOT_API}/tokens`, token);
}

function update(token) {
  return api.put(`${process.env.VUE_APP_ROOT_API}/tokens/${token._id}`, token);
}

function destroy(id) {
  return api.delete(`${process.env.VUE_APP_ROOT_API}/tokens/${id}`);
}